import { useMutation } from 'react-query'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { GeneratedTheme } from 'screens/ContentPlan/CreateCampaignModal/Types'

export interface ThemePreviewVariables {
  content_strategy_type: string
  start_date: string
  length: number
  goal?: string
  existing_themes?: Array<{ id: string; title?: string; description: string }>
}

interface Props {
  brandPlanId: number
}

interface Data {
  theme: GeneratedTheme
}

export type Options = Omit<UseMutationOptions<Data, Error, ThemePreviewVariables>, 'mutationFn'>

const generateThemePreview = async ({
  workspaceId,
  brandPlanId,
  ...variables
}: ThemePreviewVariables & Props & { workspaceId: number }) => {
  const res = await sendToApi<Data>(`/w/${workspaceId}/brand_plans/${brandPlanId}/theme_previews`, {
    method: 'POST',
    body: variables,
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error('Failed to generate theme preview. Please try again.')
  }

  return res.data
}

export const useGenerateThemePreview = ({ brandPlanId }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation<Data, Error, ThemePreviewVariables>(
    (variables) => generateThemePreview({ brandPlanId, workspaceId, ...variables }),
    options,
  )
}
